module.exports = __webpack_public_path__ + "cd.383deb4011a564f1a70f.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/cd.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/cd.svg
// module chunks = styles